import MuiCheckbox from '@mui/material/Checkbox';
import type { CheckboxProps as MuiCheckboxProps } from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { forwardRef } from 'react';

export type CheckboxProps = Pick<
  MuiCheckboxProps,
  'checked' | 'defaultChecked' | 'indeterminate' | 'disabled' | 'onChange' | 'tabIndex' | 'inputRef' | 'size' | 'name'
> & {
  label?: React.ReactNode;
  /** Smaller control + label (e.g. Jewish date picker "אחרי השקיעה"). */
  density?: 'default' | 'compact';
};

/** Design-system Checkbox — use `label` for labeled options; wraps `FormControlLabel` when set. */
export const Checkbox = forwardRef<HTMLButtonElement, CheckboxProps>(function Checkbox(
  {
    checked,
    defaultChecked,
    indeterminate,
    disabled,
    onChange,
    tabIndex,
    inputRef,
    size = 'medium',
    name,
    label,
    density = 'default'
  },
  ref
) {
  const control = (
    <MuiCheckbox
      ref={ref}
      className={['SmCheckbox-root', density === 'compact' && 'SmCheckbox-root--compact'].filter(Boolean).join(' ')}
      checked={checked}
      defaultChecked={defaultChecked}
      indeterminate={indeterminate}
      disabled={disabled}
      onChange={onChange}
      tabIndex={tabIndex}
      inputRef={inputRef}
      size={size}
      name={name}
    />
  );

  if (label == null) return control;

  return (
    <FormControlLabel
      className={density === 'compact' ? 'SmCheckbox-formLabel--compact' : undefined}
      control={control}
      label={label}
      disabled={disabled}
    />
  );
});
